import { phoneSettingsOnFocusVysionEvents } from './onFocus';
import { phoneSettingsClickVysionEvents } from './click';
import { phoneSettingsViewVysionEvents } from './view';
import { EventData, handleVysionEvent } from '../vysionService';
import { VYSION_ACTIONS } from '..';

export const events = {
  [VYSION_ACTIONS.ON_FOCUS]: { ...phoneSettingsOnFocusVysionEvents },
  [VYSION_ACTIONS.CLICK]: { ...phoneSettingsClickVysionEvents },
  [VYSION_ACTIONS.VIEW]: { ...phoneSettingsViewVysionEvents },
};

export const handlePhoneSettingsVysionEvent = (data: EventData): void => {
  handleVysionEvent<typeof events>(data, events);
};
